import { useState } from "react";
import { topicTags } from "@/mocks/homeData";

const toneStyles: Record<string, string> = {
  primary: "bg-primary-50 text-primary-700 border-primary-200 hover:border-primary-400",
  secondary: "bg-secondary-50 text-secondary-800 border-secondary-200 hover:border-secondary-400",
  accent: "bg-accent-50 text-accent-800 border-accent-200 hover:border-accent-400",
};

const activeStyles: Record<string, string> = {
  primary: "bg-primary-500 text-background-50 border-primary-500 dark:text-foreground-950",
  secondary: "bg-secondary-500 text-background-50 border-secondary-500 dark:text-foreground-950",
  accent: "bg-accent-500 text-foreground-950 border-accent-500",
};

export default function TopicWall() {
  const [activeTag, setActiveTag] = useState<string>("顶流塌房");

  return (
    <section id="topics" className="mx-auto max-w-[1400px] px-4 py-12 md:px-6 md:py-16">
      <div className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-8">
        <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
          <div>
            <h2 className="flex items-center gap-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              <span className="flex h-7 w-7 items-center justify-center">
                <i className="ri-hashtag text-accent-500" />
              </span>
              话题墙
            </h2>
            <p className="mt-2 text-sm text-foreground-500">
              点选一个话题，看看大家正在追哪些热门爆料与最新讨论。
            </p>
          </div>
          <span className="rounded-full border border-background-300 px-3 py-1 text-xs text-foreground-600">
            共 {topicTags.length} 个在追话题
          </span>
        </div>

        <div className="flex flex-wrap gap-2.5 md:gap-3">
          {topicTags.map((tag) => {
            const isActive = activeTag === tag.label;
            return (
              <button
                key={tag.label}
                type="button"
                onClick={() => setActiveTag(tag.label)}
                className={`flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-full border px-4 py-2 text-sm font-medium transition-all ${
                  isActive ? activeStyles[tag.tone] : toneStyles[tag.tone]
                }`}
              >
                {tag.label}
                <span
                  className={`rounded-full px-1.5 py-0.5 text-[10px] ${
                    isActive ? "bg-background-50/25 text-background-50 dark:text-foreground-950" : "bg-background-100 text-foreground-500"
                  }`}
                >
                  {tag.count}
                </span>
              </button>
            );
          })}
        </div>

        <div className="mt-6 flex flex-wrap items-center gap-3 rounded-md bg-background-100 px-4 py-3">
          <span className="flex items-center gap-1.5 text-sm text-foreground-700">
            <i className="ri-focus-3-line text-primary-500" />
            当前话题：
            <strong className="font-semibold text-foreground-950">{activeTag}</strong>
          </span>
          <a
            href="#stories"
            className="ml-auto flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 hover:text-primary-700"
          >
            查看该话题爆料
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}